export default {
  "foot": {
    "title": "Century Games Players",
    "p1": "Enter your User ID to link your account, pay for the top-up. The amount will be updated in your associated account directly. If it does not show up, please reload the game or contact customer suppport if needed.",
    "p2": "If you have any questions, please feel free to contact the customer support. Thank you for your support!",
    "copyright": "© Copyright 2024 Century Games.",
    "service": "Terms of Service",
    "policy": "Privacy Policy",
    "descriptionTitle": "How Does This Work?"
  },
  "accept": {
    "title": "This website uses cookies to make your browsing experience better. Please read our <a href=\"https://www.centurygames.com/privacy-policy/\" style=\"color: #58a8a5;\">Privacy Policy</a>  for information on what we collect on our website. By continuing to use this site, you agree that we may store and access cookies on your device.",
    "decline": "Decline",
    "accept": "Accept"
  },
  "game": {
    "inapptext": "Or Login via Game",
    "loginfail": "Login Failed",
    "logintip": "If the game failed to authorize, please update the game to the latest version or try another browser.",
    "reloadmsg": "Please tap the 'Reload' button to get the login result.",
    "reload": "Reload",
    "appnotice": "If you want to log in through the game app, please use an external browser to open the store.",
    "changeaccount": "Are you sure you want to log out of your account?",
    "login": "Log In",
    "notice": "Notice",
    "confirm": "Confirm",
    "loginuserid": "User ID",
    "palceholder": "Enter User ID",
    "okbtn": "OK",
    "loginbtn": "Login via Game",
    "changebtn": "Or Login with User ID",
    "useTitle": "ACCOUNT",
    "checkBtn": "Check",
    "findid": "Couldn't find your User ID?",
    "checktext": "Find your User ID from Settings in game, or tap the question mark for\nquidance.",
    "username": "Nickname:",
    "userId": "User ID : ",
    "packageTitle": "TOP-UP AMOUNT",
    "edit": "Edit",
    "paymentTitle": "PAYMENT METHOD",
    "total": "Total",
    "goPay": "Pay Now",
    "noSelectPackageTips": "You did not select any amount",
    "payFail": "PAYMENT FAILED",
    "camelPayfail": "Payment Failed",
    "payFailTips1": "Please contact Adyen Customer Support",
    "payFailTips2": "Please contact Paypal Customer Support",
    "paySuccess": "PAYMENT SUCCESSFUL",
    "paySuccessTips2": "Reload the game first before contacting Customer Support for not receiving your purchase!",
    "camelPaySuccess": "Payment Successful",
    "transactionId": "Transaction ID",
    "paySuccessTips": "Item delivery may take a moment, please wait",
    "deliveryFail": "DELIVERY FAILED",
    "deliveryFailTips": "Please contact Customer Support",
    "orderTitle": "Your order summary",
    "paidWith": "Payment Method",
    "orderID": "Transaction ID",
    "payStatus": "Payment Status",
    "orderTotal": "Total Price",
    "transactionDate": "Transaction Date",
    "goOnPay": "Purchase Again",
    "getInvoice": "Receipt",
    "camelDeliveryFail": "Delivery Failure",
    "confirmOrder": "ORDER CONFIRMATION",
    "confirmFollow": "Please confirm the following:",
    "nickname": "Nickname",
    "packageName": "Items",
    "totalPayment": "Total Price",
    "confirmPayWith": "Payment Method",
    "confirmAndGoOn": "Confirm & Proceed with Payment",
    "orderCancel": "Cancel",
    "getInvoiceTitle": "SEND VIA EMAIL",
    "getInvoiceTips": "If you would like to receive the receipt by email, please enter an email address.",
    "getInvoiceTips1": "Enter your email to get the receipt",
    "getInvoiceTips2": "Agree to our collection and storage of your email address.",
    "getInvoiceTips3": "Agree to receive emails about discounts, promotions and more for our games via email.",
    "invoiceSend": "Send",
    "sendSuccess": "Receipt Email Sent",
    "id404": "User ID not found",
    "packageLoadingText": "Shop items updating...",
    "taxTips": "Price includes taxes",
    "adyenTips": "The payment service is provided by Adyen, which operates under a banking license and is supervised by the Dutch Central Bank. If you have any inquiries about its Certifications, please refer to <a href=\"https://www.adyen.com/platform/certifications\">https://www.adyen.com/platform/certifications</a>. As for how they protect your data, please refer to <a href=\"https://www.adyen.com/policies-and-disclaimer/privacy-policy\">https://www.adyen.com/policies-and-disclaimer/privacy-policy</a>.",
    "paypalTips": "The payment service is provided by PayPal. As for how they protect your data, please refer to <a href=\"https://www.paypal.com/c2/webapps/mpp/ua/privacy-full\">https://www.paypal.com/c2/webapps/mpp/ua/privacy-full</a>",
    "switchCountryTips": "Your preferred country/region is ${servercountry}. Would you like to switch country and currency?",
    "paypalBtn": "Pay Now with Card",
    "paypalOr": "Or",
    "paypalCard1": "Cardholder Name (optional)",
    "paypalCard2": "Card Number",
    "checkUserID": "Link",
    "success": "SUCCESS",
    "changeCurrencyContent": "Would your like to switch the region and currency to match your in-game setting: ${servercountry}？",
    "productDescription": "Farm Bucks are a cash equivalent that can be used to purchase any packs and deals in the game.",
    "payButton": "PAY",
    "userIdNotice": "Please enter your User ID to link your game account first.",
    "account": "Account",
    "card": "Card",
    "notification": "Enter your User ID to link your account, select your desired items then pay with your preferred payment method. After reloading the game, purchased items will show up in your account, ready for use.\n\nIf you have any questions, please feel free to contact customer support in game.",
    "rongluRank": "Furnace Level:",
    "tips": "How to use it?",
    "checkTIps1": "I have read and agree to the <a :href=\"policyUrl\">\"Privacy Policy\"</a>, <a :href=\"serviceURl\">\"Terms of Service\"</a> and <a :href=\"paymentURl\">\"Payment Terms and Condition\"</a>.",
    "checkTIps2": "Please read and tick the checkbox",
    "selectTips": "(Currency of the most recent in-game purchase will be selected)",
    "koPayTips": "If your bank card used Korean Won as a foreign currency, the Dynamic Currency Conversion (DCC) service will be used, and an additional handling fee may be charged by a third-party proxy and not this website.",
    "PayTips": "If your bank card used a foreign currency, the Dynamic Currency Conversion (DCC) service will be used, and an additional handling fee may be charged by a third-party proxy and not this website."
  },
  "invoice": {
    "title": "Receipt",
    "transactionId": "Transaction ID",
    "transactionDate": "Transaction Date",
    "totalAmount": "Total Amount",
    "paymentMethod": "Payment Method",
    "description": "Description",
    "game": "Game",
    "quantity": "Quantity",
    "price": "Price",
    "amount": "Amount",
    "total": "Total Amount",
    "footTitle": "Notes",
    "footContent": "Thank you for supporting Century Games!",
    "button1": "Get Receipt",
    "button2": "Back with No Receipt",
    "giveupInvoice": "You will not receive the receipt for the order. Confirm?"
  },
  "payment": {
    "card": "Credit Card / Debit Card",
    "paypal": "PayPal"
  },
  "country": {
    "countryTitle1": "COUNTRY / REGION",
    "Africa": "Africa",
    "America": "America",
    "Asia": "Asia",
    "Europe": "Europe",
    "Oceania": "Oceania",
    "ZA": "South Africa",
    "US": "United States",
    "HK": "Hong Kong, China",
    "JP": "Japan",
    "KR": "Korea",
    "SG": "Singapore",
    "SA": "Saudi Arabia",
    "IQ": "Iraq",
    "TW": "Taiwan, China",
    "TH": "Thailand",
    "GB": "United Kingdom",
    "AU": "Australia",
    "countryLanguage1": "LANGUAGE",
    "AE": "United Arab Emirates",
    "DE": "Germany",
    "PT": "Portugal",
    "RU": "Russia",
    "ES": "Spain",
    "CH": "Switzerland",
    "TR": "Turkey",
    "KW": "Kuwait",
    "QA": "Qatar",
    "PL": "Poland",
    "ID": "Indonesia",
    "IT": "Italy",
    "IN": "India",
    "FR": "France",
    "CA": "Canada",
    "NL": "Netherlands",
    "AT": "Austria",
    "RS": "Serbia",
    "SE": "Sweden",
    "MY": "Malaysia",
    "BE": "Belgium",
    "DK": "Denmark",
    "FI": "Finland",
    "PH": "Philippines",
    "NO": "Norway",
    "BR": "Brazil",
    "NZ": "New Zealand",
    "UA": "Ukraine",
    "RO": "Romania"
  },
  "extra_info": {
    "kingdom": "State: #"
  },
  "adyen": {
    "note": "The payment service is provided by Adyen, offering secure transactions with the highest level of PCI-DSS certification from international credit card organizations supporting both domestic and overseas card payments.",
    "note2": "Note: Tick \"Save for my next payment\" to save your payment card info in your current browser for future payments."
  },
  "pay": {
    "error1": "If something goes wrong, please try again later or use another payment method. Please contact customer support if you have more questions."
  },
  "meta": {
    "title": "Family Farm Adventure Shop",
    "description": "Family Farm Adventure Shop is the official shop of Family Farm Adventure, providing a discounted top-up channel and in-game packs for players.",
    "keywords": "farm, cultivation, market, upgrade, exploration, map, character, level, simulation, strategy, pay, store, topup, payment"
  }
};


// WEBPACK FOOTER //
// ./src/lang/EN.js